export default {"src":"/trader-new/_next/static/media/Logout.d331a1aa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};